export function getLabelPrintSource (deliveryRequest, instructions = []) {
  if (deliveryRequest?.data?.id) {
    return {
      type: 'carrier',
      deliveryRequestId: deliveryRequest.data.id
    }
  }

  const printableInstructions = instructions.filter(instruction => {
    return ['label-print', 'document-print'].includes(instruction.type)
  }).map(instruction => {
    return {
      ...instruction,
      options: {
        ...instruction.options,
        confirm: false
      }
    }
  })

  if (printableInstructions.length > 0) {
    return {
      type: 'instructions',
      instructions: printableInstructions
    }
  }

  return { type: 'missing' }
}
